import { Entity, Field } from "typegraph";

@Entity({ create: "article_playlist_one_create" })
export default class ArticlePlaylist {
	@Field()
	public id: string;

	@Field()
	public articleId: string;

	@Field()
	public name: string;

	@Field()
	public contentType: string;
}



// WEBPACK FOOTER //
// ./src/panels/kb/entities/ArticlePlaylist.ts